import { CircularProgress, Typography } from '@mui/material'
import React from 'react'

/**
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 *
 /**
  * 
/**
 * Loading component with spinner.
 *
 * @param {Object} props
 * @param {MUIColor} props.color
 * @param {string} props.waitingMessage
 * @param {number} props.size
 * @param {string} [props.padding="20px"]
 * @returns {JSX.Element} The DataLoadingSpinner component
 */
const DataLoadingSpinner = ( { color, waitingMessage, size, padding = "20px" } ) => {
    return (
        <Typography fontSize="14px" fontWeight="500" color={color || "textSecondary"} variant='caption' display="flex" padding={padding} gap="10px" alignItems="center"> <CircularProgress color={color || "primary"} size={size || 16} /> {waitingMessage} </Typography>
    )
}

export default DataLoadingSpinner
